<template>
    <div>
        <div class="relative inline group-hover/menuItem:drop-shadow-menu-item">
            <HeaderWaveIcon
                position="left"
                product="conference"
                class="left-[-66%] top-[-33%]" />
            <svg
                viewBox="0 0 53 71"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                width="53"
                height="71"
                class="overflow-visible transition-transform duration-300 group-hover/menuItem:rotate-12 group-hover/menuItem:scale-110 group-hover/menuItem:animate-ring-conference">
                <path
                    d="M49.8215 69.4986H9.17802C7.07169 69.4986 6.39644 66.6623 8.2768 65.7132L21.4532 59.0622C21.7327 58.9211 22.0414 58.8477 22.3544 58.8477H49.8215C50.926 58.8477 51.8215 59.7431 51.8215 60.8477V67.4986C51.8215 68.6032 50.926 69.4986 49.8215 69.4986Z"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    d="M46.9956 59.049V50.3774C46.9956 47.439 45.82 44.6228 43.7309 42.5566L10.2197 9.41162"
                    stroke="currentColor"
                    stroke-width="2" />
                <path
                    d="M8.25781 65.7681L51.3356 65.7681"
                    stroke="currentColor"
                    stroke-width="2" />
                <circle
                    cx="4.07034"
                    cy="4.07034"
                    r="5.07034"
                    transform="matrix(-1 0 0 1 10.6299 2)"
                    stroke="currentColor"
                    stroke-width="2" />
            </svg>
            <HeaderWaveIcon
                position="right"
                product="conference"
                class="right-[-15%] top-[-45%]" />
        </div>
    </div>
</template>

<script setup lang="ts">
import HeaderWaveIcon from '~/components/layouts/header/svg/HeaderWaveIcon.vue'
</script>
